// Add body classes about whether the user already scrolled by the header
// This is useful to apply styles like shadows to the header at appropriate times

let checkScrolledByDesktopHeader = () => window.scrollY > 130
let checkScrolledByMobileHeader = () => window.scrollY > 100

let wasScrolledByDesktopHeader = checkScrolledByDesktopHeader()
document.body.classList.toggle('scrolled-by-desktop-header', wasScrolledByDesktopHeader)

let wasScrolledByMobileHeader = checkScrolledByMobileHeader()
document.body.classList.toggle('scrolled-by-mobile-header', wasScrolledByMobileHeader)

window.addEventListener(
  'scroll',
  () => {
    const isScrolledByDesktopHeader = checkScrolledByDesktopHeader()
    if (isScrolledByDesktopHeader !== wasScrolledByDesktopHeader) {
      document.body.classList.toggle('scrolled-by-desktop-header', isScrolledByDesktopHeader)
      wasScrolledByDesktopHeader = isScrolledByDesktopHeader
    }

    const isScrolledByMobileHeader = checkScrolledByMobileHeader()
    if (isScrolledByMobileHeader !== wasScrolledByMobileHeader) {
      document.body.classList.toggle('scrolled-by-mobile-header', isScrolledByMobileHeader)
      wasScrolledByMobileHeader = isScrolledByMobileHeader
    }
  },
  { passive: true },
)
